<style scope>
.theme--light.v-table thead th {
  text-transform: capitalize !important;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}

table.v-table thead th,
table.v-table tbody td {
  font-size: 12px;
  font-weight: 400;
  height: 20px;

}
.data-item {
  cursor: pointer;
}
</style>
<template>
<v-layout>
  <!-- <v-dialog v-bind:persistent="true" v-model="dialog" width="90%">

    <v-card class="bg">

      <v-card-title>
        <span class="headline" v-if="chart.activeItem">{{ chart.activeItem.name }}</span>
        <v-btn

                    color="pink"
                    fab
                    dark
                    small
                    absolute
                    middle
                    right
                    @click="dialog = false"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
      </v-card-title>
      <v-card-text v-if="chart.chartData && chart.chartData.series">
        <apexchart v-if="chart.chartData && chart.chartData.series" height="200px" width="100%" type="bar" :options="chart.chartData.options" :series="chart.activeItems"></apexchart>
        <div style="min-height: 600px">
          <selectable-table-chart  v-if="chart.dataSource" :chart="chart" />
        </div>
        </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  <vue-perfect-scrollbar class="scroll-area" :settings="settings">
    <v-card>
      
      <v-card-title style="padding-top: 10px; padding-bottom: 0px;" v-if="chart.parameters.title.value">
        {{ chart.parameters.title.value }}
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field> -->
      </v-card-title>
   
      <table v-if="chart.chartData && chart.chartData.series" class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th :style="header.style" class="column text-xs-left" v-for="(header, index) in chart.headers" :key="index"> {{ header.text }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- @click.stop="dialog = true; chart.setActiveItem(item); -->
          <tr v-for="(item, index) in chart.chartData.series" :key="index" class="data-item"  v-on:click="aSetSubChart({chart:chart, item: item});">

            <td :style="header.style" :class="header.class" valign="middle" v-for="(header, indexColumn) in chart.headers" :key="indexColumn">

              <v-sparkline v-if="header.type == 'sparkline'" style="height: 50px" :value="item.values" :gradient="gradient" :smooth="radius || false" :padding="padding" :line-width="width" :stroke-linecap="lineCap" :gradient-direction="gradientDirection"
                auto-draw></v-sparkline>


              <div v-else-if="header.type == 'div-progress'" :style="item.divStyle">
                <div style="display: block; position: absolute; right: 5px">{{  format(item[header.value]) }}</div>
              </div>
              <span v-else>
                {{ item[header.value] }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>
  </vue-perfect-scrollbar>
</v-layout>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SelectableTableChart from '@/components/charts/table/selectable/chart.vue';
import numeral from 'numeral';
// import VueApexCharts from 'vue-apexcharts';

import {
  createNamespacedHelpers
}
from 'vuex';
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations
} = createNamespacedHelpers('dataSources')
const chartNamespace = createNamespacedHelpers('charts');

const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea']
];
export default {
  props: ['chart'],
  data: function() {
    return {
      currentItem: {},
      dialog: false,
      width: 2,
      radius: 10,
      padding: 8,
      lineCap: 'round',
      gradient: gradients[5],
      // value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      gradientDirection: 'top',
      gradients,
      settings: {
        maxScrollbarLength: 60
      },
      pagination: {
        rowsPerPage: 10000
      },
      search: '',
      headers: [{
        value: "name"
      }],
      items: [

      ],
      options: {
        chart: {
          enabled: true
        }
      }
    };
  },
  components: {
    'vue-perfect-scrollbar': VuePerfectScrollbar,
    'selectable-table-chart': SelectableTableChart
    //'apexchart': VueApexCharts
  },
  methods: {
    ...chartNamespace.mapMutations(['mSetSubChart']),
    ...chartNamespace.mapActions(['aSetSubChart']),
    format: function(val) {
      return numeral(val).format('0,0.[00]');
    }
  },
  computed: {

  },
  mounted: function() {
    /**
    let that = this;
    setInterval(function() {

      that.headers = that.chart.chartData.items;
      that.items = that.chart.chartData.data;
    }, 1000);**/
  },
  beforeDestroy() {}
}
</script>
